import { FiArrowDownLeft, FiCreditCard, FiPieChart } from 'react-icons/fi';
import { money } from './revenueData';

function RevenueMetric({ row, name, label, description, primary, icon: Icon }) {
    return <div className={`revenue-metric${primary ? ' revenue-metric-primary' : ''}`}>
        <dt><span>{label}</span><Icon aria-hidden="true" /></dt>
        <dd><span>{money(row, name)}</span><p>{description}</p></dd>
    </div>;
}

export default function RevenueCurrencyDetails({ row, publisher }) {
    const negativeBalance = Number(row.values.balance) < 0;
    const purchases = Math.max(0, Number(row.values.purchases));
    const subscriptions = Math.max(0, Number(row.values.subscriptions));
    const sourceTotal = purchases + subscriptions;
    const purchasePercent = sourceTotal > 0 ? purchases / sourceTotal * 100 : 0;
    const subscriptionPercent = sourceTotal > 0 ? subscriptions / sourceTotal * 100 : 0;
    return <section aria-label={`${row.currency.code} revenue`} className="revenue-detail">
        <h3 className="revenue-detail-heading"><span className="revenue-code">{row.currency.code}</span>{row.currency.label || row.currency.code}</h3>
        <dl className={`revenue-metrics${publisher ? ' revenue-metrics-publisher' : ''}`}>
            <RevenueMetric row={row} name="total" label={publisher ? 'Total income' : 'Total sales'} primary icon={FiPieChart}
                description={publisher ? 'Your earnings from purchases and subscriptions' : 'Sales before revenue sharing'} />
            {publisher ? <>
                <RevenueMetric row={row} name="received" label="Payments received" icon={FiArrowDownLeft} description="Publisher payments recorded in this period" />
                <RevenueMetric row={row} name="balance" label="Remaining income" icon={FiCreditCard}
                    description={negativeBalance ? 'Payments exceed earnings for this period' : 'Income less payments received for this period'} />
            </> : <RevenueMetric row={row} name="share" label="Akello share" icon={FiArrowDownLeft} description="Akello revenue after sharing" />}
        </dl>
        <div className="revenue-sources">
            <div className="revenue-sources-heading"><h4>{publisher ? 'Where your income comes from' : 'Sales by source'}</h4><span>{row.currency.code}</span></div>
            <div className="revenue-source-bar" aria-hidden="true">
                <span className="revenue-source-purchases" style={{ width: `${purchasePercent}%` }} />
                <span className="revenue-source-subscriptions" style={{ width: `${subscriptionPercent}%` }} />
            </div>
            <dl className="revenue-source-values">
                <div><dt><span className="revenue-dot revenue-source-purchases" />{publisher ? 'From purchases' : 'Purchase sales'}<span className="revenue-source-percent">{purchasePercent.toFixed(1)}%</span></dt><dd>{money(row, 'purchases')}</dd></div>
                <div><dt><span className="revenue-dot revenue-source-subscriptions" />{publisher ? 'From subscriptions' : 'Subscription sales'}<span className="revenue-source-percent">{subscriptionPercent.toFixed(1)}%</span></dt><dd>{money(row, 'subscriptions')}</dd></div>
            </dl>
            {!sourceTotal && <p className="revenue-source-note">No purchase or subscription revenue in this currency for this period.</p>}
        </div>
    </section>;
}
